import { Grid, IconButton, Typography, Button } from "@mui/material";
import { FC, useEffect, useState } from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { RoutesMap } from "../../types";
import { useNavigate, useParams } from "react-router-dom";
import { usePatternTStore } from "../../hooks/usePatternTStore";
import { ApiStatus } from "../../types/api/status";
import { CustomBackdrop } from "../../components/common/CustomBackdrop/CustomBackdrop";
import { useAuthStore } from "../../hooks";
import { Role } from "../../types/roles/roleTypes";
import { ModalConfirm } from "../../components/common/ModalConfirm/ModalConfirm";
import { PatternTSignatureModal } from "./PatternTSignatureModal";

export const PatternTSignature: FC = () => {

    const navigate = useNavigate()
    const params = useParams()
    const { id } = params
    const { user } = useAuthStore()
    const userRole: Role | any = user.userType;
    const { status: patternTStatus, getPatternTPDF, getOnePatternT, setSelectedPatternT } = usePatternTStore()

    const idpatternT: any = id
    const [pdf, setPDF] = useState<any>(null)
    const [signed, setSigned] = useState<boolean>(false)
    const [showModalFirm, setShowModalFirm] = useState<boolean>(false)
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)

    useEffect(() => {
        setLocalData()
    }, [])

    const setLocalData = async () => {
        const patternR = await getOnePatternT(idpatternT)
        setSelectedPatternT(patternR)
        if (patternR && Object.entries(patternR).length > 0) {
            if (userRole === Role.MAINTENANCE && patternR.signings.idsignings_boss_maintenance !== null) {
                setSigned(true)
            } else if (userRole === Role.MECHANIC && patternR.signings.idsignings_mechanic !== null) {
                setSigned(true)
            }
            await showPDF(idpatternT)
        }
    }

    const handleBack = () => {
        if (userRole === Role.MECHANIC && !signed) {
            setShowModalConfirm(true)
        } else {
            navigate({ pathname: RoutesMap.PATTERN_T_LIST })
        }
    }

    const showPDF = async (idpatternT) => {
        const pdf = await getPatternTPDF(idpatternT)
        const blob = new Blob([pdf], { type: 'application/pdf' })
        const bloblURL = URL.createObjectURL(blob)
        setPDF(bloblURL)
    }

    const onConfirmBack = async () => {
        navigate({ pathname: RoutesMap.PATTERN_T_LIST })
    }

    return (
        <Grid container>
            {patternTStatus === ApiStatus.FETCHING && <CustomBackdrop open={true} />}
            <Grid item xs={12} display='flex' alignItems='center' sx={{ marginLeft: '-25px' }}>
                <IconButton size="small" color="primary" aria-label="view" onClick={() => handleBack()}>
                    <ArrowBackIcon fontSize='small' />
                </IconButton>
                <Typography>Volver</Typography>
            </Grid>
            <Grid item container sx={{ alignItems: "center", display: "flex", justifyContent: "center", flexWrap: "wrap", marginBottom: "10px" }}>
                <Typography variant="h6" component="h1" gutterBottom color="#808080" className="tittle" sx={{ mt: 1, ml: 1, fontWeight: 600 }}>
                    PAUTA DE CHEQUEO SEMIREMOLQUES
                </Typography>
            </Grid>
            {
                !signed && (userRole === Role.MECHANIC || userRole === Role.MAINTENANCE) && (
                    <Grid item xs={12} sx={{ textAlign: "right" }}>
                        <Button
                            onClick={() => setShowModalFirm(true)}
                            sx={{ border: "solid 1px #73B2FF", m: "10px", color: "#73B2FF", width: '150px', "&:hover": { bgcolor: "#73B2FF", color: "#fff" } }}
                        >
                            FIRMAR
                        </Button>
                    </Grid>
                )
            }
            <Grid container style={{ overflow: 'hidden !important', height: '100%', alignItems: 'center', textAlign: 'center' }}>
                <iframe src={pdf} id="pdfVer" height="1000px" width="100%"></iframe>
            </Grid>
            {
                showModalFirm && (
                    <PatternTSignatureModal
                        open={showModalFirm}
                        closeModal={() => setShowModalFirm(false)}
                        idpatternT={idpatternT}
                    />
                )
            }
            {
                showModalConfirm && (
                    <ModalConfirm
                        open={showModalConfirm}
                        closeModal={() => { setShowModalConfirm(false) }}
                        onCancel={() => { setShowModalConfirm(false) }}
                        onConfirm={onConfirmBack}
                        title="¿Está seguro de salir?"
                        text="La pauta aún no ha sido firmada."
                    />
                )
            }
        </Grid>
    )
}